import { useState } from "react";
import api from "../services/api";

export default function DashboardDesafiosDia({ desafios, onCheckinDone }) {
  const [openId, setOpenId] = useState(null);
  const [inputs, setInputs] = useState({});

  const toggleAccordion = (id) => {
    setOpenId(openId === id ? null : id);

    setTimeout(() => {
      const el = document.getElementById(`accordion-${id}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
  };

  const handleChangeFile = (id, file) => {
    setInputs((prev) => ({
      ...prev,
      [id]: { ...prev[id], evidencia: file },
    }));
  };

  const handleChangeObs = (id, value) => {
    setInputs((prev) => ({
      ...prev,
      [id]: { ...prev[id], observacao: value },
    }));
  };

  const handleSubmit = async (id) => {
    try {
      const formData = new FormData();
      formData.append("desafio", id);

      if (inputs[id]?.evidencia) {
        formData.append("evidencia", inputs[id].evidencia);
      }

      if (inputs[id]?.observacao) {
        formData.append("observacao", inputs[id].observacao);
      }

      await api.post("/checkins/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Check-in registrado!");

      setOpenId(null);

      // 🔥 Atualiza o Dashboard automaticamente
      if (onCheckinDone) {
        onCheckinDone();
      }
    } catch (err) {
      console.error(err);
      alert("Erro ao registrar check-in");
    }
  };

  return (
    <div>
      {desafios.map((d) => (
        <div key={d.id} className="card shadow-sm mb-3 p-3">

          {/* HEADER DO CARD */}
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              {d.emoji} {d.titulo}
            </h5>

            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => toggleAccordion(d.id)}
            >
              {openId === d.id ? "fechar" : "ver desafio"}
            </button>
          </div>

          {/* ACCORDION */}
          {openId === d.id && (
            <div id={`accordion-${d.id}`} className="mt-3 border-top pt-3">

              {/* BLOCO IDÊNTICO AO NEWCHECKIN */}
              <div className="mb-3">
                <p className="mb-1">
                  <strong>Tipo:</strong> {d.tipo_nome}
                </p>

                <p className="mb-1">
                  <strong>Sprint:</strong> {d.sprint}
                </p>

                <p className="mb-0">
                  <strong>Descrição:</strong> {d.descricao}
                </p>
              </div>

              {/* EVIDÊNCIA */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Evidência</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) =>
                    handleChangeFile(d.id, e.target.files[0])
                  }
                />
              </div>

              {/* OBSERVAÇÕES */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Observações</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="observações opcionais"
                  value={inputs[d.id]?.observacao || ""}
                  onChange={(e) =>
                    handleChangeObs(d.id, e.target.value)
                  }
                />
              </div>

              <button
                className="btn btn-primary w-100"
                onClick={() => handleSubmit(d.id)}
              >
                Registrar check-in
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
